<template lang="html">
<div class="v-scope-home-oferta-el">
<article class="oferta row-start aifs">

    <div class="contenedor-textos">

      <h3 v-if="!!data.empresa" class="empresa" :style="style.colorMediumBlack">{{data.empresa}}</h3>

      <h2 class="title-dato">{{data.titulo}}</h2>

      <h3 v-if="brand.showReferenciaOferta" class="tipo" :style="style.colorButton">{{$t('oferta.referencia')}} {{data.idoferta}}</h3>

      <p class="status" :status="data.estado" v-if="!!data.estado & !!dominios.estadosCandidaturasAlumno">{{dominios.estadosCandidaturasAlumno[data.estado]}}</p>

      <p class="motivoestado" v-if="!!data.descripcionEstadoMotivo">{{data.descripcionEstadoMotivo}}</p>

      <div class="info column-center">
        <p class="-fecha" v-if="!!data.fecha">{{data.fecha}}</p>
        <p class="-lugar" v-if="!!data.provincia">
          <template v-if="data.nombreIsla"> {{data.nombreIsla}},</template>
          {{data.provincia}}
        </p>
      </div>

    </div>

    <candidaturaOptions :url="data.urlAcceso" v-if="data.estado == 16" :type="type"></candidaturaOptions>


    <router-link :to="`${$t(`enlaces.ofertas_${type}`)}/${data.urlAcceso}`" class="enlace-cover" v-if="!iscandidatura"></router-link>
    <router-link :to="`${$t(`enlaces.mis_candidaturas`)}/${data.urlAcceso}`" class="enlace-cover" v-if="iscandidatura"></router-link>







  </article>
</div>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import VeeValidate from 'vee-validate';

  import candidaturaOptions from '@/components/views/ofertas/candidatura-options';

  export default {
    name: 'oferta-el',
    props: ['data', 'type', 'iscandidatura'],
    data() {
      return {
        clicked: false
      }
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominios',
        style: 'getStyles',
        colors: 'basicColors',
        brand: 'getBrand'
      }),
      getIslaNamebyId() {
        if (this.data.idIsla) {
          let value = this.data.idIsla
          Object.values(this.dominios.islas).forEach(d => {
            if (this.data.idIsla == d.idIsla) {
              value = d.descripcion
            }
          })
          return value
        }
      },
    },
    components: {
      'candidaturaOptions': candidaturaOptions
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/home/oferta-el.vue